const cat0_input = document.getElementById('searchCat0');

cat0_input.addEventListener('input', showCat0Results);

function showCat0Results(e) {

	var subCats = document.getElementsByClassName('cat-item');
	var subCatFound = false;

	for (var i = 0; i < subCats.length; i++) {
		var subCat = subCats.item(i).dataset.name.toLowerCase();

		if(e.target.value.length > 1 && !subCat.includes(e.target.value.toLowerCase().trim())) {
			subCats.item(i).hidden = true;			 
		} else {
			subCats.item(i).hidden = false;
			subCatFound = true;
		}
	}	

	if(!subCatFound) {
		if(e.target.value.length > 1) document.getElementById('noSubCatFound').hidden = false;
		else document.getElementById('noSubCatFound').hidden = true;
		$('.cat-item').attr('hidden',false);
	} else {
		document.getElementById('noSubCatFound').hidden = true;
	}

}